export const computeProgressBarStatus = (
  pickupDate: string | Date,
  deliveryDate: string | Date
): number => {
  const startDate = new Date(pickupDate);
  const endDate = new Date(deliveryDate);

  const windowMs = endDate.getTime() - startDate.getTime();

  // Guard against a zero-length (or inverted) window — e.g. identical pickup and
  // delivery timestamps — which would otherwise produce NaN/Infinity progress.
  // !isFinite also catches NaN produced by an invalid date string.
  if (!isFinite(windowMs) || windowMs <= 0) {
    return Date.now() >= startDate.getTime() ? 100 : 0;
  }

  return Math.ceil(((Date.now() - startDate.getTime()) / windowMs) * 100);
};
